import axios from "axios";

const api = axios.create({
  baseURL:
    window.location.hostname === "localhost"
      ? "http://localhost:5000/api"
      : `${process.env.REACT_APP_API_BASE_URL}/api`,
});

export default api;